import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { ROUTES } from 'enrollment/app/routes';
import { PsButtonTuner } from 'stencilSetup';
import { StyledUL, StyledLoaderBox } from './BundledBenefitsStyled';
import { useBenefitCategoryQuery } from 'enrollment/queries';
import { queryKeyGenerator } from 'theSource/utils';
import { selectEnrollmentContext } from 'theSource/features/Home/components/EnrollmentBanner/services';
import { useConfigurationQuery } from 'theSource/queries/useConfigurationQuery';
import { Loader } from 'theSource/components';
import { BenefitDto } from 'enrollment/queries/useBenefitCategoryQuery/types';

export const BundledBenefitsLoader = () => {
  const { t } = useTranslation('pages.bundledBenefits');
  const navigate = useNavigate();
  const enrollmentContext = useSelector(selectEnrollmentContext);
  const { configuration } = useConfigurationQuery();
  const lumosApiHost = configuration?.apiHost;

  const { data, isLoading, isFetching } = useBenefitCategoryQuery({
    key: queryKeyGenerator(`benefits-${enrollmentContext}`),
    enrollmentContextType: enrollmentContext,
    enabled: true,
    lumosApiHost: String(lumosApiHost),
    includeEligibleDependentsData: true,
  });

  const handleOnClick = () => {
    const bundledOrgBenefitIds = data?.data?.bundled_org_benefit_ids;
    const AdditionalPlanInfo = data?.data?.benefits?.some(
      (benefit: BenefitDto) =>
        benefit.coverage &&
        benefit.coverage.has_popup_content &&
        bundledOrgBenefitIds?.includes(benefit.benefit.org_benefit_id)
    );
    if (AdditionalPlanInfo) {
      navigate(`/enrollment${ROUTES.enrollment.AdditionalPlanInfo.path}`, {
        state: {
          fromSavviPage: true,
        },
      });
    } else {
      navigate(`/enrollment${ROUTES.enrollment.benefits.path}`);
    }
  };

  return (
    <StyledLoaderBox
      className="align-items-center justify-content-center"
      data-testid="bundled-benefits-loading-continue-page"
    >
      <StyledUL>
        <li>
          <p className="body1">{t('loader.ul1')}</p>
        </li>
        <li>
          <p className="body1">{t('loader.ul2')}</p>
        </li>
      </StyledUL>
      <p className="body1 ml-3_5 my-3">{t('loader.content')}</p>
      {isLoading || isFetching ? (
        <Loader />
      ) : (
        <PsButtonTuner
          buttonId="continue-button"
          data-testid="continue-button"
          label={t('common:continue')}
          level="primary"
          onClick={handleOnClick}
          extraClass="ml-3_5"
        />
      )}
    </StyledLoaderBox>
  );
};
